import React, { useState } from "react";

function FaqSearch({varSearchData, setSearchData, setPageNum, varFaqTypeList,onManageFaqTypeHandler}) {
  //항목별 검색변수값 설정
  const [varSearchType, setSearchType] = useState(varSearchData.searchType);
  const [varSearchOption, setSearchOption] = useState(varSearchData.searchOption);
  const [varSearchString, setSearchString] = useState(varSearchData.searchString);
  
  //검색분류 선택값 저장
  const onSearchTypeHandler = (e) => {   
    setSearchType(Number(e.currentTarget.value));
  }
  //검색항목 선택값 저장
  const onSearchOptionHandler = (e) => {   
    setSearchOption(e.currentTarget.value);
  }
  //검색문자 저장
  const onSearchStringHandler = (e) => {   
    setSearchString(e.currentTarget.value);
  }
  //검색시작
  const onExecuteSearchingHandler = (e) => {
    e.preventDefault();
    setSearchData({
      searchType:varSearchType,
      searchOption:varSearchOption,
      searchString:varSearchString
    });
    setPageNum(1);
  }

  //검색정보 초기화
  const onClearSearchHandler = (e) => {
    e.preventDefault();
    setSearchData({
      searchType:0,
      searchOption:"all",
      searchString:""
    });
    setPageNum(1);
    setSearchType(0);
    setSearchOption("all");
    setSearchString("");
  }

  return (
    <div className="main-box">
      <div className="search-area">
        <div className="search-box">
          <button onClick={(e)=>onManageFaqTypeHandler(e)} className="btn">FAQ 분류 관리</button>
        </div>
        {/*검색항목*/}
        <div className="search-string">
          <select value={varSearchOption.searchType} name="searchType" style={{width:"200px"}} onChange={(e)=>onSearchTypeHandler(e)}>
            <option value={0}>분류선택</option>
            {varFaqTypeList.map((types,i)=>(
              <option key={'types_'+i} value={types.vf_idx}>{types.vf_name}</option>
            ))}
          </select>
          <select value={varSearchOption} style={{width:"150px"}} onChange={(e)=>onSearchOptionHandler(e)}>
              <option value={"all"}>전체</option>
              <option value={"board_title"}>제목</option>
              <option value={"board_comment"}>내용</option>
          </select>
          <input type="text" value={varSearchString} onChange={(e)=>onSearchStringHandler(e)} placeholder="검색어를 입력해주세요"/>
          <button onClick={(e)=>onExecuteSearchingHandler(e)} className="btn">조회</button>
          <button onClick={(e)=>onClearSearchHandler(e)} className="btn black">초기화</button>
        </div>
      </div>
    </div>
  );
}

export default FaqSearch;